<template>
    <div class="rating-component mt-4 mb-2">
        <div class="review-categories">
            <div class="flex">
                <div class="w-28 bg-gray-200 h-1 mb-auto mt-auto">
                    <div :id="`communication-rating-bar-`+random"
                        class="bg-green-500 h-1 rounded-r-full"></div>
                </div>
                <span class="ml-2">Communication: {{ reviews.communication.toFixed(1) }}</span>
            </div>
            <div class="flex">
                <div class="w-28 bg-gray-200 h-1 mb-auto mt-auto">
                    <div :id="`cleanliness-rating-bar-` + random"
                        class="bg-green-500 h-1 rounded-r-full"></div>
                </div>
                <span class="ml-2">Cleanliness: {{ reviews.cleanliness.toFixed(1) }}</span>
            </div>
            <div class="flex">
                <div class="w-28 bg-gray-200 h-1 mb-auto mt-auto">
                    <div :id="`location-rating-bar-` + random"
                        class="bg-green-500 h-1 rounded-r-full"></div>
                </div>
                <span class="ml-2">Location: {{ reviews.location.toFixed(1) }}</span>
            </div>
        </div>
        <div class="review-categories">
            <div class="flex">
                <div class="w-28 bg-gray-200 h-1 mb-auto mt-auto">
                    <div :id="`facilities-rating-bar-` + random"
                        class="bg-green-500 h-1 rounded-r-full"></div>
                </div>
                <span class="ml-2">Facilities: {{ reviews.facilities.toFixed(1) }}</span>
            </div>
            <div class="flex">
                <div class="w-28 bg-gray-200 h-1 mb-auto mt-auto">
                    <div :id="`value-rating-bar-` + random"
                        class="bg-green-500 h-1 rounded-r-full"></div>
                </div>
                <span class="ml-2">Value: {{ reviews.value.toFixed(1) }}</span>
            </div>
            <div class="flex">
                <div class="w-28 bg-gray-200 h-1 mb-auto mt-auto">
                    <div :id="`accuracy-rating-bar-` + random"
                        class="bg-green-500 h-1 rounded-r-full">
                    </div>
                </div>
                <span class="ml-2">Accuracy: {{ reviews.accuracy.toFixed(1) }}</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'AllReviewsRatingComponent',
    props: ['reviews'],
    methods: {
        setRatingBar(category, reviewCategory) {
            const ratingBar = document.querySelector('#' + category + '-rating-bar-' + this.random);
            const percent = (reviewCategory / 5) * 100
            ratingBar.style.width = percent + "%";
        },
        fillCategories() {
            this.setRatingBar('communication', this.reviews.communication );
            this.setRatingBar('cleanliness', this.reviews.cleanliness );
            this.setRatingBar('location', this.reviews.location );
            this.setRatingBar('facilities', this.reviews.facilities );
            this.setRatingBar('value', this.reviews.value );
            this.setRatingBar('accuracy', this.reviews.accuracy);
        },
    },
    mounted() {
        this.fillCategories();
        this.random = new Date().valueOf();
    },
    data: function () {
        return {
            random: ""
        }
    },
}
</script>
<style>
.rating-component {
    width: fit-content;
    opacity: 0.7;
}
.review-categories {
    display: inline-block;
    padding-left: 1rem;
}

 @media (max-width: 500px) {
.review-categories {
        padding-left: 0px;
    }
 }
</style>
